module.exports = __webpack_public_path__ + "img/offline_img.8cf610d2.png";